'use strict';

exports.__esModule = true;

var _webUtils = require('@vezeeta/web-utils');

var _Authenticate = require('./Authenticate');

var _Authenticate2 = _interopRequireDefault(_Authenticate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AuthApi = function (_API) {
  _inherits(AuthApi, _API);

  function AuthApi() {
    var _temp, _this, _ret;

    _classCallCheck(this, AuthApi);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _API.call.apply(_API, [this].concat(args))), _this), _this.getAuthHeader = function () {
      return _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);
    }, _this.getCulture = function () {
      return _webUtils.Cookie.get(_webUtils.Cookie.CULTURE);
    }, _this.makeRequest = function (type, body, url, reqHeaders, shouldCache) {
      var reqHeadersFinal = reqHeaders || [];

      reqHeadersFinal.push({
        key: 'Language',
        value: _this.getCulture()
      }, {
        key: 'ActionSource',
        value: process.env.REACT_APP_ACTION_SOURCE
      }, {
        key: 'x-vzt-authentication',
        value: _this.getAuthHeader()
      });

      return new Promise(function (resolve, reject) {
        return _API.prototype.makeRequest.call(_this, type, body, url, reqHeadersFinal, shouldCache).then(function (response) {
          if (_webUtils.STATUS.isNotAuthorized(response.status) || _webUtils.STATUS.isForbidden(response.status)) {
            (0, _Authenticate2.default)(resolve(response), response.status);
          } else {
            resolve(response);
          }
        }).catch(function (error) {
          reject(error);
        });
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * @override General wrapper for fetch method
   * @param {string} type
   * @param {string} url
   * @param {obj} body
   * @param {array} reqHeaders
   */


  return AuthApi;
}(_webUtils.API);

exports.default = AuthApi;
module.exports = exports['default'];